import b from 'b_';
import { Popup, Text } from 'platform-components';
import { POPUP_AXIS, POPUP_DIRECTIONS, POPUP_THEMES } from 'platform-components/constants';
import { withRouterPath, InjectedProps as WithRouterPathProps } from 'platform-components/hocs';
import React from 'react';
import { connect } from 'react-redux';
import ym from 'react-yandex-metrika';
import { accessibleClick } from '@edu-frontend/modules/src/shared/lib/a11y';

// @ts-ignore
import { IconMenu } from 'common.components/icon2';
import * as themesSelectors from 'store/themes/selectors';

import Tabs from '../__tabs/theme-page__tabs';
import { ReduxTeacherStore } from '../../../typings';
import SectionMenu from '../../library.section-menu/section-menu';
import { DisplayOptions } from '../typings';

import './theme-page__menu.scss';

interface StoreProps {
    themeId: number;
    isActualTheme: boolean;
}

interface OwnProps extends WithRouterPathProps {
    displayOptions: DisplayOptions;
}

interface Props extends StoreProps, OwnProps {}

interface State {
    menuShown: boolean;
}

class ThemePageMenu extends React.PureComponent<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            menuShown: false,
        };
    }

    componentDidUpdate(prevProps: Props): void {
        const { themeId: prevThemeId } = prevProps;
        const { themeId, match } = this.props;
        const themeHasChanged = themeId !== prevThemeId;
        const teamHasChanged = match?.params?.classId !== prevProps.match?.params?.classId;

        if ((themeHasChanged || teamHasChanged) && this.popupRef) {
            this.popupRef.hide();
            this.popupRef.updatePositions();
        }
    }

    menuButtonRef: React.ReactNode | null;
    popupRef: Popup | null;

    setMenuButtonRef = (ref: HTMLDivElement | null) => {
        if (ref === null) {
            return;
        }

        //@ts-ignore - EDUCATION-37077: [react-update]: fixme typings: Хочет HtmlDivElem вместo ReactNode
        this.menuButtonRef = ref;
    };

    setPopupRef = (ref: Popup | null) => {
        if (ref === null) {
            return;
        }

        this.popupRef = ref;

        if (this.menuButtonRef && this.popupRef) {
            this.popupRef.setOwner(this.menuButtonRef);
        }
    };

    toggleMenu = () => {
        const { menuShown } = this.state;

        ym('reachGoal', 'teacher_lesson_creation_topic_alltopics');

        if (!this.popupRef) {
            return;
        }

        if (menuShown) {
            this.popupRef.hide();
        } else {
            this.popupRef.show();
        }
    };

    handleModalToggle = ({ shown }: { shown: boolean }): boolean => {
        this.setState({ menuShown: shown });

        return false;
    };

    render() {
        const {
            displayOptions: { shouldShowSectionMenu, shouldHideMenu, shouldHideTabs },
            isActualTheme,
        } = this.props;
        const { menuShown } = this.state;

        return (
            <div className={b('theme-page', 'menu', { empty: shouldHideMenu })}>
                <Tabs shouldHideTabs={shouldHideTabs} />
                {shouldShowSectionMenu && (
                    <React.Fragment>
                        <div className={b('theme-page', 'paranja', { shown: menuShown })} />
                        {shouldShowSectionMenu && (
                            <React.Fragment>
                                <div
                                    className={b('theme-page', 'section-menu', { shown: menuShown })}
                                    {...accessibleClick(this.toggleMenu)}
                                    ref={this.setMenuButtonRef}
                                >
                                    <IconMenu mix="theme-page__section-menu-icon" />
                                    <Text id="library.problems.allThemes" weight={Text.WEIGHT.M} />
                                </div>
                                <Popup
                                    autoclosable
                                    axis={POPUP_AXIS.END}
                                    direction={POPUP_DIRECTIONS.BOTTOM}
                                    mix="theme-page__section-menu-popup"
                                    offsetTop={-8}
                                    onToggle={this.handleModalToggle}
                                    ref={this.setPopupRef}
                                    theme={POPUP_THEMES.CLEAN}
                                >
                                    <SectionMenu isActualThemes={isActualTheme} />
                                </Popup>
                            </React.Fragment>
                        )}
                    </React.Fragment>
                )}
            </div>
        );
    }
}

const mapStateToProps = (storeState: ReduxTeacherStore, ownProps: OwnProps): StoreProps => {
    const {
        match: {
            params: { themeId: thId },
        },
    } = ownProps;
    const themeId = Number(thId);

    return {
        themeId,
        isActualTheme: themesSelectors.getIsActualTheme(storeState, { themeId }),
    };
};

export default withRouterPath(connect(mapStateToProps)(ThemePageMenu));
